import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/stores/useAuthStore'
import { refreshAccessToken } from '@/api/axiosApi'

export function useTokenRefresh() {
  const isRefreshing = useRef(false)

  useEffect(() => {
    const interval = setInterval(async () => {
      const { needsRefresh, accessToken, clear } = useAuthStore.getState()

      if (!accessToken || isRefreshing.current) return
      if (!needsRefresh()) return

      isRefreshing.current = true
      try {
        await refreshAccessToken()
      } catch {
        clear()
        window.location.href = '/login'
      } finally {
        isRefreshing.current = false
      }
    }, 60_000)

    return () => clearInterval(interval)
  }, [])
}
